module.exports = __webpack_public_path__ + "img/status.c122686c.png";